export default "__VITE_ASSET__6e8b4a45__"